/** @file viewportEngine: the editor viewport's Babylon engine (full resolution, MSAA on). */
import { Engine } from '@babylonjs/core/Engines/engine.js';
import { ENGINE_OPTIONS } from '@zilo/pose3d-runtime-babylon/canvas/engineOptions';

/**
 * The runtime's context options with antialias on and no device-ratio scaling (`cameraControl` sizes the backing
 * store to CSS x dpr). The puppet stays pixel-exact: it renders into its own nearest-sampled target (`puppetLayer`).
 */
export function viewportEngine(canvas: HTMLCanvasElement): Engine {
  return new Engine(canvas, true, { ...ENGINE_OPTIONS, antialias: true }, false);
}
